<template>
	<div class="d-flex flex-column h-100">
		<router-view />
	</div>
</template>
<script setup>
</script>